import React, { useContext } from "react";
import clsx from "clsx";
import firebase from "../../firebase";
import { SnackbarAlert } from "../SnackbarAlert";
import { AuthContext } from "../../auth";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CancelRoundedIcon from "@material-ui/icons/CancelRounded";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  button: {
    color: theme.palette.error.main,
    textTransform: "none",
    padding: theme.spacing(1),
    borderRadius: 8,
    fontSize: "1.3em",
    fontWeight: 600,
    letterSpacing: 1,
  },
  secondaryText: {
    color: theme.palette.text.secondary,
  },
  dialog: {
    padding: theme.spacing(1),
    width: "auto",
    color: theme.palette.common.white,
  },
  dialogActionsDelete: {
    background: "hsl(0, 0%, 97%)",
  },
  dialogTitleDelete: {
    background: "linear-gradient(to right bottom, #f55041, #f44336)",
  },
}));

const styles = (theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[50],
    fontSize: 40,
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, action, className, classes, ...other } = props;
  return (
    <MuiDialogTitle disableTypography {...other} className={className}>
      <Typography component="div">
        <Box
          fontSize={24}
          fontWeight="fontWeightBold"
          letterSpacing={0.7}
          p={1}
        >
          {children}
        </Box>
      </Typography>
      {action ? (
        <span>
          <Tooltip
            title="Close"
            enterDelay={300}
            leaveDelay={200}
            enterNextDelay={300}
          >
            <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={action}
            >
              <CancelRoundedIcon />
            </IconButton>
          </Tooltip>
        </span>
      ) : null}
    </MuiDialogTitle>
  );
});

const DeleteForm = (props) => {
  const classes = useStyles();
  const { currentUser } = useContext(AuthContext);
  const { setSnackbarState } = useContext(SnackbarAlert);

  const [deleting, setDeleting] = React.useState(false);

  const handleDelete = async () => {
    try {
      setDeleting(true);
      if (props.fromPost) {
        //delete comment or reply
        await firebase
          .database()
          .ref("comments")
          .child(props.fromPost)
          .child(props.id)
          .remove();
      } else {
        //delete post
        await firebase
          .database()
          .ref(`posts/${props.urlParam}/${props.id}`)
          .remove();
      }
      setTimeout(() => {
        setDeleting(false);
        props.close();
        setSnackbarState({
          state: true,
          message: "Successfully deleted! 👍",
          status: "info",
        });
      }, 0);
    } catch (error) {
      setTimeout(() => {
        setDeleting(false);
        props.close();
        setSnackbarState({
          state: true,
          message: "Something went wrong. 😟",
          status: "error",
        });
      }, 0);
    }
  };

  return (
    <>
      <DialogTitle
        id="form-dialog-title"
        action={props.close}
        className={clsx(classes.dialog, classes.dialogTitleDelete)}
      >
        {props.fromPost ? (
          <span>Delete Comment</span>
        ) : (
          <span>Delete Post</span>
        )}
      </DialogTitle>
      <DialogContent>
        <Typography component="div">
          <Box
            letterSpacing={0.5}
            fontSize={20}
            fontWeight={600}
            p={1}
            className={classes.secondaryText}
          >
            Are you sure you want to delete this{" "}
            {props.fromPost ? <span>comment</span> : <span>post</span>}?
          </Box>
          <Box
            fontSize={14}
            fontWeight={400}
            className={classes.secondaryText}
            p={1}
          >
            This action is irreversible.
          </Box>
        </Typography>
      </DialogContent>

      <DialogActions
        className={clsx(classes.dialog, classes.dialogActionsDelete)}
      >
        <Button
          variant="text"
          className={classes.button}
          disabled={deleting}
          onClick={handleDelete}
          fullWidth
        >
          Delete
        </Button>
      </DialogActions>
    </>
  );
};

export default DeleteForm;
